/**
 * Created by neo on 02.12.20.
 *
 * Plain TypeScript type - no MobX observables.
 */
import { WeekDayEntryBase, parseWeekDayEntry } from './WeekDayEntry';
import { EventEntry, defaultEventEntry } from './EventEntry';

export type WeekDayEntryEvent = WeekDayEntryBase & {
  type: 'event';
  event: EventEntry;
};

export function parseWeekDayEntryEvent(json?: any): WeekDayEntryEvent {
  return {
    ...parseWeekDayEntry({ ...json, type: 'event' }),
    type: 'event' as const,
    event: defaultEventEntry(json?.event),
  };
}

/** @deprecated Use parseWeekDayEntryEvent instead */
export const createWeekDayEntryEvent = parseWeekDayEntryEvent;
